"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RewardList = void 0;
class RewardList extends Array {
    constructor(...items) {
        super(...items);
        this.getSortedList = () => {
            const items = [
                ...this.getOrderByCustomOrder(...this.getFeatured().getWithCustomOrder()),
                ...this.getNewestFirst(...this.getFeatured().getWithoutCustomOrder()),
                ...this.getOrderByCustomOrder(...this.getNonFeatured().getWithCustomOrder()),
                ...this.getNewestFirst(...this.getNonFeatured().getWithoutCustomOrder())
            ];
            return new RewardList(...items);
        };
        this.getWithCustomOrder = () => new RewardList(...this.filter(x => x.customOrder > 0));
        this.getWithoutCustomOrder = () => new RewardList(...this.filter(x => x.customOrder < 1));
        this.getOrderByCustomOrder = (...items) => new RewardList(...items.sort((x, y) => (x.customOrder > y.customOrder ? -1 : 1)));
        this.getNewestFirst = (...items) => new RewardList(...items.sort((x, y) => {
            const dateStartX = !!x.date_start ? x.date_start : 0;
            const dateStartY = !!y.date_start ? y.date_start : 0;
            return dateStartX > dateStartY ? -1 : 1;
        }));
        this.getDateStartSorted = () => this.sort((x, y) => {
            const dateStartX = !!x.date_start ? x.date_start : 0;
            const dateStartY = !!y.date_start ? y.date_start : 0;
            return dateStartX > dateStartY ? -1 : 1;
        });
        this.getNonHidden = () => new RewardList(...this.filter(x => !x.isHiddenFromList));
        this.sortByFeatured = () => {
            if (this.length > 0) {
                this.sort((o1, o2) => {
                    const fom1 = o1.featured_order_num;
                    const fom2 = o2.featured_order_num;
                    if (fom1 == null && fom2 == null) {
                        return (o2.date_start ? o2.date_start : 0) - (o1.date_start ? o1.date_start : 0);
                    }
                    else if (fom1 == null && fom2 != null) {
                        return 1;
                    }
                    else if (fom2 == null && fom1 != null) {
                        return -1;
                    }
                    return fom2 - fom1;
                });
            }
        };
        this.getPage = (itemsPerPage, page) => {
            let result = new RewardList();
            const start = page * itemsPerPage;
            const end = start + itemsPerPage;
            if (this.length > 0 && page >= 0 && start < this.length) {
                const rewards = this.slice(start, end);
                result = new RewardList(...rewards);
            }
            return result;
        };
        this.getFeatured = () => {
            const items = this.filter((reward) => reward.featured_order_num !== undefined && reward.featured_order_num !== null);
            return new RewardList(...items);
        };
        this.getNonFeatured = () => {
            const items = this.filter((reward) => !reward.featured_order_num);
            return new RewardList(...items);
        };
        this.filterCategories = (categories) => {
            const result = [];
            if (categories) {
                categories.forEach(item => {
                    if (this.find(element => {
                        return element.category_id ? element.category_id.toString() === item.id.toString() : false;
                    })) {
                        result.push(item);
                    }
                });
            }
            return result;
        };
        this.filterByCategory = (category) => {
            let result = new RewardList();
            if (category) {
                const filtered = this.filter(element => {
                    return element.category_id ? element.category_id.toString() === category.id.toString() : false;
                });
                result = new RewardList(...filtered);
            }
            return result;
        };
    }
}
exports.RewardList = RewardList;
RewardList.getCombinedSortedList = (rewardList, other = []) => {
    const combinedList = [...rewardList, ...other];
    const list = Array.from(new Set(combinedList.map(x => x.id)))
        .map(rewardId => combinedList.find(x => x.id === rewardId))
        .filter(x => !!x);
    return new RewardList(...list).getSortedList();
};
//# sourceMappingURL=RewardList.js.map